export default "__VITE_ASSET__BgSwOkrW__"